import type { ReactNode } from "react";

const BULLET_PREFIX = /^\s*•\s*/;

function linkifySegment(text: string): ReactNode[] {
  const re = /([\w.+-]+@[\w.-]+\.[a-z]{2,})/gi;
  const out: ReactNode[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  const s = text;
  while ((m = re.exec(s)) !== null) {
    if (m.index > last) {
      out.push(s.slice(last, m.index));
    }
    out.push(
      <a
        key={`${m.index}-${m[0]}`}
        href={`mailto:${m[0]}`}
        className="text-[#4CAF50] hover:underline"
      >
        {m[0]}
      </a>,
    );
    last = re.lastIndex;
  }
  if (last < s.length) {
    out.push(s.slice(last));
  }
  return out;
}

/** Renders Flutter-style legal copy: `\n\n` paragraphs, `•` bullets, linkified emails. */
export function LegalProse({ text }: { text: string }) {
  const blocks = text.split(/\n\n/);

  return (
    <div className="mb-6 space-y-4 text-gray-700">
      {blocks.map((block, bi) => {
        const lines = block
          .split("\n")
          .map((l) => l.trim())
          .filter(Boolean);
        if (lines.length === 0) {
          return null;
        }

        const allBullets = lines.every((l) => BULLET_PREFIX.test(l));
        if (allBullets) {
          return (
            <ul key={bi} className="mb-0 list-disc space-y-2 pl-6">
              {lines.map((l, i) => (
                <li key={i}>
                  {linkifySegment(l.replace(BULLET_PREFIX, ""))}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={bi} className="mb-0">
            {lines.map((line, li) => (
              <span key={li}>
                {li > 0 ? <br /> : null}
                {linkifySegment(line)}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
